import { Howl, Howler } from 'howler';
import { TweenMax } from 'gsap/TweenMax';

import eventHub from './eventHub';

class Sound {
  constructor() {
    this.state = {
      bgVolume: 1,
      interactionVolume: 0.25,
      volume: 0.5,
      isPlaying: false,
    };

    this.backgroundSound = new Howl({
      src: ['/audio/background.mp3'],
      autoplay: false,
      loop: true,
      volume: this.state.bgVolume,
    });

    this.interactionSound = new Howl({
      src: ['/audio/interaction.mp3'],
      autoplay: false,
      loop: false,
      volume: this.state.interactionVolume,
    });

    this.addEvents();
  }

  addEvents() {
    eventHub.$on('soundInteraction', () => this.playSoundInteraction());
  }

  toggleAudio() {
    TweenMax.killTweensOf(this.state);

    if (this.state.isPlaying) {
      this.state.isPlaying = false;
      TweenMax.to(this.state, 0.5, {
        volume: '-=0.5',
        onUpdate: () => {
          Howler.volume(this.state.volume);
        },
        onComplete: () => {
          this.backgroundSound.pause();
        },
      });
    } else {
      this.state.isPlaying = true;
      TweenMax.to(this.state, 0.5, {
        volume: '+=0.5',
        onStart: () => {
          this.backgroundSound.play();
          this.interactionSound.play();
        },
        onUpdate: () => {
          Howler.volume(this.state.volume);
        },
      });
    }
  }

  playSoundInteraction() {
    if (!this.state.isPlaying) return;

    this.interactionSound.play();
  }
}

export default new Sound();
